import { render, staticRenderFns } from "./batchAddScrapProducts.vue?vue&type=template&id=cfe217b4&"
import script from "./batchAddScrapProducts.vue?vue&type=script&lang=js&"
export * from "./batchAddScrapProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports